import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge that knows the design-system tokens. Without this it reads
 * `text-heading-h1` (a font size) as a text colour, so
 * `cn('text-heading-h1', 'text-text-secondary')` would silently drop the size.
 * Keep these lists in step with tokens.css.
 */
export const twMergeConfig = {
  extend: {
    theme: {
      text: [
        'display-lg',
        'display-sm',
        'heading-h1',
        'heading-h2',
        'heading-h3',
        'heading-h4',
        'body-lg',
        'body-lg-strong',
        'body-md',
        'body-md-strong',
        'body-sm',
        'body-sm-strong',
        'label-lg',
        'label-md',
        'label-sm',
        'caption',
        'overline',
        'data-md',
        'data-lg',
        'data-stat',
        'avatar-20',
        'avatar-24',
        'avatar-56',
        'avatar-80',
        'caption-burn-in',
      ],
      shadow: ['xs', 'sm', 'md', 'lg', 'overlay', 'focus-ring', 'focus-input'],
      radius: ['none', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', 'full'],
    },
  },
};

const twMerge = extendTailwindMerge(twMergeConfig);

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
